import '../../Base/ProcessCopy.less'

interface ProcessProps {
  isDirectEnquiry: boolean
  className?: string
}

const ProcessCopy = ({ isDirectEnquiry, className }: ProcessProps): JSX.Element => (
  <ol className={`process-overview ${className ? className : ''}`}>
    <li>
      <span className='list-text'>Tell us what you are looking for</span>
    </li>
    <li>
      <span className='list-text'>
        {isDirectEnquiry
          ? "We'll also share your enquiry with other suitable venues"
          : "We'll share your enquiry with suitable venues"}
      </span>
    </li>
    <li>
      <span className='list-text'>Get messages from venues & match with your favourites</span>
    </li>
  </ol>
)

export default ProcessCopy
